// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './style.css';
import { registerServiceWorker } from './utils/appUpdate';

registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);